"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _GridListModule = _interopRequireDefault(require("./../../scss/GridList.module.scss"));
function GridList(_ref) {
  let {
    children,
    numberOfColumns = 2,
    headerText = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, headerText !== '' && /*#__PURE__*/_react.default.createElement("h3", {
    className: [_GridListModule.default['grid-list-header'], 'grid-list-header'].join(' ')
  }, headerText), /*#__PURE__*/_react.default.createElement("ul", {
    className: _GridListModule.default['grid-list'],
    style: {
      gridTemplateColumns: "repeat(".concat(numberOfColumns, ", 1fr)")
    }
  }, children));
}
var _default = exports.default = GridList;